export const NET_ERR_MSG = '服务异常，请稍后再试';

export const NET_REQUEST_SUCCESS = '操作成功';

export const LOGIN_OUTTIME = '登录状态过期，请重新登录';

export const ORDER_STATUS = {
  1: '待审核',
  2: '待发货',
  '2-2': '充值中...',
  3: '待收货',
  4: '已完成',
  5: '已关闭'
};

export const ORDER_STATUS_ICON = {
  1: 'clock-o',
  2: 'clock-o',
  3: 'clock-o',
  4: 'passed',
  5: 'warning-o'
};
